const { clientWidth, clientHeight } = document.documentElement;

export default {
  default: {
    desktop: {
      x: 0,
      y: 0,
      w: 99,
      h: 29.5,
      minw: 26,
      minh: 22,
      maxw: 99,
      maxh: 1000
    },
    overheadDesktop: {
      x: clientWidth / 2 - 550 / 2,
      y: clientHeight / 2 - (clientHeight * 0.8) / 2,
      w: 550,
      h: clientHeight * 0.8
    }
  },
  Map: {
    desktop: {
      w: 99,
      h: 29.5,
      minw: 26,
      minh: 22,
      maxw: 99,
      maxh: 1000
    },
    overheadDesktop: {
      w: clientWidth,
      h: clientHeight,
      minw: 210,
      minh: 210,
      maxw: clientWidth,
      maxh: clientHeight
    },
    singleMode: true
  },
  Map3D: {
    desktop: {
      w: 99,
      h: 29.5,
      minw: 26,
      minh: 22,
      maxw: 99,
      maxh: 1000
    },
    overheadDesktop: {
      w: clientWidth,
      h: clientHeight,
      minw: 210,
      minh: 210,
      maxw: clientWidth,
      maxh: clientHeight
    },
    singleMode: true
  },
  MapBI: {
    desktop: {
      w: 99,
      h: 29.5,
      minw: 26,
      minh: 22,
      maxw: 99,
      maxh: 1000
    },
    overheadDesktop: {
      w: clientWidth,
      h: clientHeight,
      minw: 210,
      minh: 210,
      maxw: clientWidth,
      maxh: clientHeight
    },
    singleMode: true
  },
  Book: {
    desktop: {
      w: 99,
      h: 29.5,
      minw: 26,
      minh: 22,
      maxw: 99,
      maxh: 1000
    },
    overheadDesktop: {
      x: 50,
      y: 50,
      w: clientWidth - 400,
      h: clientHeight - 300,
      minw: 482,
      minh: 160,
      maxw: clientWidth - 100,
      maxh: clientHeight - 100
    }
  },
  Layers: {
    desktop: undefined,
    overheadDesktop: {
      x: 115,
      y: 50,
      w: 281,
      h: 439,
      minw: 169,
      minh: 114,
      maxw: 411,
      maxh: 930
    },
    singleMode: true
  },
  palette: {
    desktop: undefined,
    overheadDesktop: {
      x: clientWidth - 559,
      y: 75,
      w: 514,
      h: clientHeight - 7,
      minw: 502,
      minh: 244,
      maxw: 630,
      maxh: 880
    }
  },
  Heatmap: {
    desktop: undefined,
    overheadDesktop: {
      x: 249,
      y: 499,
      w: 281,
      h: 439,
      minw: 267,
      minh: 140,
      maxw: 553,
      maxh: 661
    }
  },
  Densitymap: {
    desktop: undefined,
    overheadDesktop: {
      x: 249,
      y: 499,
      w: 281,
      h: 439,
      minw: 267,
      minh: 140,
      maxw: 553,
      maxh: 661
    }
  }
};
